import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { steps } from "../../initiator";

const CreateQueryTabContent = ({
    activeTab,
    onNextButtonClicked,
    onBackButtonClicked,
    onCancelButtonClicked,
    goToTab
}) => {
    const currentStep = steps.find((iTab) => iTab.stepUniqueKey === activeTab)

    if(!currentStep) return null
    
    return (
        <div className="product-creating-tabs-content">
            <div className={`product-creating-content-item ${activeTab}`}>
                <currentStep.component 
                    onNextButtonClicked={onNextButtonClicked}
                    onBackButtonClicked={onBackButtonClicked}
                    onCancelButtonClicked={onCancelButtonClicked}
                    goToTab={goToTab}
                />
            </div>
        </div>
    )
}

export default withNamespaces()(
    withRouter(CreateQueryTabContent)
);